import {jsx} from 'panel';

import {QueryBlockEl} from 'common/widgets/query-block';

import type {QueryEntrySection} from '../index';
import type {QueryBehaviorEntry} from '../types';

export function BehaviorRowDateRange({
  el,
  entry,
  index,
}: {
  el: QueryEntrySection;
  entry: QueryBehaviorEntry;
  index: number;
}) {
  return (
    <QueryBlockEl
      attrs={{
        type: `time`,
        'display-context': el.attr(`time-display-context`),
        'max-data-history-days': el.attr(`max-data-history-days`),
        'selector-icon': `calendar`,
        'project-id': el.attr(`project-id`),
        'workspace-id': el.attr(`workspace-id`),
        selected: entry.dateRange || el.helpers.getDefaultDateValue(),
        theme: `select`,
        'project-as-of-date': el.attr(`project-as-of-date`),
      }}
      on={{
        select: (ev: CustomEvent) => el.helpers.onDateRangeChange(ev, index),
        track: el.helpers.preventTracking,
      }}
    />
  );
}
